import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, FormControlLabel, Checkbox } from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { adminChangePasswordPin } from "../../../util/API/admin";

const generateRandomPassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const array = new Uint32Array(8);
    window.crypto.getRandomValues(array);
    
    return Array.from(array, (num) => chars[num % chars.length]).join('');
};

const generateRandomPin = () => {
    const array = new Uint8Array(4);
    window.crypto.getRandomValues(array);

    return Array.from(array, (num) => (num % 10)).join(''); // Ensures only digits (0-9)};
}

const PinPasswordReset = ({ handleClose }) => {
    const [newUsername, setNewUsername] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPin, setNewPin] = useState("");
    const [alert, setAlert] = useState({ 
        showAlert: false, 
        severity: "error", 
        header: "", 
        message: "",
        additionalInformation: {}
    });
    const [isEmail, setIsEmail] = useState(true);
    const [unlockReset, setUnlockReset] = useState(false);
    const [pinOnly, setPinOnly] = useState(false);

    useEffect(() => {
        setNewPassword(generateRandomPassword());
        setNewPin(generateRandomPin());
    }, []);

    const handleSubmit = async (event, pin) => {
        try {
            if (!newUsername) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "Please enter a username",
                    header: "Error!"
                });
                return;
            }

            if (!pinOnly && !newPassword) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "Please enter a password",
                    header: "Error!"
                });
                return;
            }

            if (pinOnly && !newPin) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "Please enter a pin",
                    header: "Error!"
                });
                return;
            }

            const response = await adminChangePasswordPin(
                unlockReset,
                newUsername,
                newPin,
                pinOnly,
                newPassword
            );

            if (response?.callStatus === "1") {
                setAlert({
                    header: "Success",
                    message: "Reset was successful",
                    severity: "success",
                    showAlert: true,
                    additionalInformation: {
                        "Username": response?.Username,
                        "New Pin": response?.pin,
                        "New Password": response?.Password,
                        "Account Reset": response?.acctreset
                    }
                });

                setNewUsername("");
                setNewPassword(generateRandomPassword());
                setNewPin(generateRandomPin());
            } else {
                setAlert({
                    header: "Error",
                    message: response?.payload?.msg,
                    severity: "error",
                    showAlert: true
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Box 
            sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                backgroundColor: "#f5f5f5", 
                padding: "16px" 
            }}
        >
            <Box 
                sx={{ 
                    backgroundColor: "#ffffff", 
                    borderRadius: "8px", 
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", 
                    width: "500px", 
                    padding: "24px", 
                    textAlign: "center", 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center" 
                }}
            >

                <Typography 
                    variant="h6" 
                    sx={{ 
                        marginBottom: "16px", 
                        color: "#333333", 
                        fontWeight: "bold" 
                    }}
                >
                    Pin/Password Reset
                </Typography>

                <TextField 
                    label={isEmail ? "Enter username" : "Enter new mobile number only"} 
                    variant="outlined" 
                    fullWidth 
                    sx={{ marginBottom: "16px" }} 
                    value={newUsername} 
                    onChange={(e) => setNewUsername(e.target.value)} 
                />

                <TextField 
                    label="New Password" 
                    variant="outlined" 
                    fullWidth 
                    sx={{ marginBottom: "16px" }} 
                    type="text" 
                    value={newPassword} 
                />
                <TextField 
                    label="New PIN" 
                    variant="outlined" 
                    fullWidth 
                    sx={{ marginBottom: "16px" }} 
                    type="text" 
                    value={newPin} 
                />

                <FormControlLabel 
                    control={
                        <Checkbox 
                            checked={unlockReset} 
                            onChange={(e) => setUnlockReset(e.target.checked)} 
                        />
                    } 
                    label="Unlock / Verify / Reset Counters" 
                />

                <FormControlLabel 
                    control={
                        <Checkbox 
                            checked={pinOnly} 
                            onChange={(e) => setPinOnly(e.target.checked)} 
                        />
                    } 
                    label="PIN Only" 
                    sx={{ marginBottom: "16px" }} 
                />

                <BaseButton buttonText="Submit" onClick={(e) => handleSubmit(e)} />
            </Box>

            <CustomAlert 
                severity={alert.severity} 
                show={alert.showAlert} 
                header={alert.header} 
                message={alert.message} 
                onClick={(prev) => { 
                    setAlert({ ...prev, showAlert: false }) 
                }} 
                additionalInformation={alert.additionalInformation}
                autoclose={false}
            />
        </Box>
    );
};

export default PinPasswordReset;
